(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8811],{

/***/ 4776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Df": function() { return /* binding */ lightP; },
/* harmony export */   "wx": function() { return /* binding */ pointShapeDivider; },
/* harmony export */   "zs": function() { return /* binding */ featureList; }
/* harmony export */ });
/* harmony import */ var src_components_Modal_Types_SaveSearch_Content_styles_css_ts_vanilla_css_node_modules_vanilla_extract_webpack_plugin_virtualFileLoader_dist_vanilla_extract_webpack_plugin_virtualFileLoader_cjs_js_fileName_src_components_Modal_Types_SaveSearch_Content_styles_css_ts_vanilla_css_source_LmpienNyMjAgewogIGNvbG9yOiAjNTI1MjUxOwogIGZvbnQtc2l6ZTogMTRweDsKfQouamJ6c3IyMSB7CiAgZm9udC1zaXplOiAxNXB4OwogIG92ZXJmbG93OiBoaWRkZW47CiAgdGV4dC1vdmVyZmxvdzogZWxsaXBzaXM7CiAgd2hpdGUtc3BhY2U6IG5vd3JhcDsKfQouamJ6c3IyMiB7CiAgYmFja2dyb3VuZC1jb2xvcjogIzFEMUQxQjsKICBib3JkZXItcmFkaXVzOiA1MCU7CiAgZGlzcGxheTogaW5saW5lLWJsb2NrOwogIGhlaWdodDogNHB4OwogIG1hcmdpbjogOHB4OwogIHZlcnRpY2FsLWFsaWduOiBtaWRkbGU7CiAgd2lkdGg6IDRweDsKfQouamJ6c3IyMjpsYXN0LWNoaWxkIHsKICBkaXNwbGF5OiBub25lOwp9_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41779);
/* harmony import */ var src_components_Modal_Types_SaveSearch_Content_styles_css_ts_vanilla_css_node_modules_vanilla_extract_webpack_plugin_virtualFileLoader_dist_vanilla_extract_webpack_plugin_virtualFileLoader_cjs_js_fileName_src_components_Modal_Types_SaveSearch_Content_styles_css_ts_vanilla_css_source_LmpienNyMjAgewogIGNvbG9yOiAjNTI1MjUxOwogIGZvbnQtc2l6ZTogMTRweDsKfQouamJ6c3IyMSB7CiAgZm9udC1zaXplOiAxNXB4OwogIG92ZXJmbG93OiBoaWRkZW47CiAgdGV4dC1vdmVyZmxvdzogZWxsaXBzaXM7CiAgd2hpdGUtc3BhY2U6IG5vd3JhcDsKfQouamJ6c3IyMiB7CiAgYmFja2dyb3VuZC1jb2xvcjogIzFEMUQxQjsKICBib3JkZXItcmFkaXVzOiA1MCU7CiAgZGlzcGxheTogaW5saW5lLWJsb2NrOwogIGhlaWdodDogNHB4OwogIG1hcmdpbjogOHB4OwogIHZlcnRpY2FsLWFsaWduOiBtaWRkbGU7CiAgd2lkdGg6IDRweDsKfQouamJ6c3IyMjpsYXN0LWNoaWxkIHsKICBkaXNwbGF5OiBub25lOwp9_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(src_components_Modal_Types_SaveSearch_Content_styles_css_ts_vanilla_css_node_modules_vanilla_extract_webpack_plugin_virtualFileLoader_dist_vanilla_extract_webpack_plugin_virtualFileLoader_cjs_js_fileName_src_components_Modal_Types_SaveSearch_Content_styles_css_ts_vanilla_css_source_LmpienNyMjAgewogIGNvbG9yOiAjNTI1MjUxOwogIGZvbnQtc2l6ZTogMTRweDsKfQouamJ6c3IyMSB7CiAgZm9udC1zaXplOiAxNXB4OwogIG92ZXJmbG93OiBoaWRkZW47CiAgdGV4dC1vdmVyZmxvdzogZWxsaXBzaXM7CiAgd2hpdGUtc3BhY2U6IG5vd3JhcDsKfQouamJ6c3IyMiB7CiAgYmFja2dyb3VuZC1jb2xvcjogIzFEMUQxQjsKICBib3JkZXItcmFkaXVzOiA1MCU7CiAgZGlzcGxheTogaW5saW5lLWJsb2NrOwogIGhlaWdodDogNHB4OwogIG1hcmdpbjogOHB4OwogIHZlcnRpY2FsLWFsaWduOiBtaWRkbGU7CiAgd2lkdGg6IDRweDsKfQouamJ6c3IyMjpsYXN0LWNoaWxkIHsKICBkaXNwbGF5OiBub25lOwp9_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs_js__WEBPACK_IMPORTED_MODULE_0__);

var featureList = 'jbzsr21';
var lightP = 'jbzsr20';
var pointShapeDivider = 'jbzsr22';

/***/ }),

/***/ 12321:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[home]/[city]",
      function () {
        return __webpack_require__(41052);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 41052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _context_Cities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54673);
/* harmony import */ var _heads_listings_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6067);
/* harmony import */ var _page_commons_ListingsByCityPage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84127);
// @ts-ignore




/**
 * This page shows content for
 *  - /<lang>/<houses-for-sale>/<city>
 *  - /<lang>/<houses-for-sale>/<city>-provincia
 *
 * @param areas array with a single element, AreaDescription for the primary city in area (i.e. /milano, /rho, /milano-provincia will have the same value)
 * @param cities all the cities in the area where the current city belongs (i.e. /milano, /rho, /milano-provincia will have the same list)
 * @param city the name of the city in kebab case, or null if <CITY>-provincia
 * @param geoSlugs the single geo-slug for the city when a single city, or the list of geo-slugs for all cities in the area in any other case
 * @param user the current user | null
 * @constructor
 */ var HomeCityPage = function(param) {
    var areas = param.areas, cities = param.cities, city = param.city, geoSlugs = param.geoSlugs, user = param.user;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_context_Cities__WEBPACK_IMPORTED_MODULE_1__/* .CitiesProvider */ .Ft, {
            areas: areas,
            cities: cities,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heads_listings_map__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_page_commons_ListingsByCityPage__WEBPACK_IMPORTED_MODULE_3__/* .ListingsByCityPage */ .U, {
                        canonicalFilter: undefined,
                        city: city,
                        geoSlugs: geoSlugs,
                        user: user
                    })
                ]
            })
        })
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (HomeCityPage);
 // @ts-ignore


/***/ }),

/***/ 41779:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5949,8009,7385,8396,3406,6347,9590,4776,7769,2715,2153,5829,7275,2675,9848,6908,2456,613,9774,2888,179], function() { return __webpack_exec__(12321); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);